import { LIST_ITEMS_PER_PAGE_LIST } from '../../constants/constants';
import { TSparePartListActions } from './sparepart-list.actions';
import { TSparePartListInfoActionType, TSparePartListState } from './sparepart-list.models';

export const intialState: TSparePartListState = {
  sparePartListingInfo: null,
  sparePartRequestListingInfo: null,
  sparePartListingPagination: { pageNo: 1, pageSize: LIST_ITEMS_PER_PAGE_LIST[0] },
  sparePartRequestPagination: { pageNo: 1, pageSize: LIST_ITEMS_PER_PAGE_LIST[0] },
};

export function sparePartListReducer(state = intialState, action: TSparePartListActions): TSparePartListState {
  switch (action.type) {
    case TSparePartListInfoActionType.SetSparePartListPagination:
      return {
        ...state,
        sparePartListingPagination: action.pagination,
      };
    case TSparePartListInfoActionType.GetSparePartList:
      return {
        ...state,
        sparePartListingInfo: null,
      };
    case TSparePartListInfoActionType.GetSparePartListSuccess:
      return {
        ...state,
        sparePartListingInfo: {
          res: action.sparePartListRes,
          fetchReason: action.fetchReason,
        },
      };
    case TSparePartListInfoActionType.SetSparePartRequestPagination:
      return {
        ...state,
        sparePartRequestPagination: action.pagination,
      };
    case TSparePartListInfoActionType.GetSparePartRequestList:
      return {
        ...state,
        sparePartRequestListingInfo: null,
      };
    case TSparePartListInfoActionType.GetSparePartRequestListSuccess:
      return {
        ...state,
        sparePartRequestListingInfo: {
          res: action.sparePartRequestListRes,
          fetchReason: action.fetchReason,
        },
      };
    default:
      return state;
  }
}
